import { createFileRoute } from '@tanstack/react-router'
import { EmployersPageStructured } from '@/components/infoPages/EmployersPageStructured'
import { withPublicPageSeo } from '@/modules/seo'

const EmployersPageWithSeo = withPublicPageSeo('forEmployers', EmployersPageStructured)

export const Route = createFileRoute('/$lang/for-employers')({
  component: EmployersPageWithSeo,
})
